import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TooltipDirective } from '../../atoms/tooltip/tooltip.directive';
import { TranslocoDecimalPipe } from '@jsverse/transloco-locale';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    TooltipDirective,
    TranslocoDecimalPipe,
  ],
  selector: 'ui-badge-indicator',
  template: `
    <ng-container *transloco="let t">
      <div
        uiTooltip
        [tooltipTitle]="tooltipTitleTemplate"
        class="w-full flex justify-end"
      >
        <div
          class="flex flex-row items-center justify-center w-fit gap-x-2 px-3 rounded-full bg-gray-100 text-black"
        >
          <span
            class="py-1 text-xs min-w-max flex gap-x-0.5 justify-end items-end"
          >
            {{ value() | translocoDecimal:{ minimumFractionDigits: 2, maximumFractionDigits: 2 , useGrouping: false  } }}
            <span class="text-xs leading-1">{{ units() }}</span>
          </span>
          <div class="w-0.5 h-7 bg-neutral-6"></div>
          <span class="py-1 text-xs min-w-5">
            {{ percentage() | translocoDecimal:{ minimumFractionDigits: 0, maximumFractionDigits: 0 , useGrouping: false  } }}%
          </span>
        </div>
      </div>

      <ng-template #tooltipTitleTemplate let-data>
        <div class="flex flex-col items-center text-xs mt-0.5">
          <span>{{ tooltipLabel() }}: {{ nominal() | translocoDecimal }} {{ units() }}</span>
        </div>
      </ng-template>
    </ng-container>
  `,
})
export class BadgeIndicatorComponent {
  value = input<number>(0);
  percentage = input<number>(0);
  nominal = input<number>(0);
  units = input<string>();
  tooltipLabel = input<string>();
}
